'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearsAfter.js
// module id = 762
// module chunks = 0